import { userConstants } from "../../constant";

export function jobs(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_JOBS:
      return action.jobs;
    default:
      return state;
  }
}
